import { useContext } from 'react'
import { ServicesContext } from '../../../Context/ServicesContextProvider';

function useGetServicesContext() {
    const context = useContext(ServicesContext)
    if (!context) {
        throw new Error(" useGetServicesContext must be used inside an ServicesContextProvider")
     }
    return context;
}

export default useGetServicesContext